import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { usePastorAuth } from "../lib/pastorAuth";
import { ArchWindow } from "../components/ArchWindow";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setPastor } = usePastorAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const finish = async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setPastor(data);
        window.history.replaceState(null, "", location.pathname);
        navigate("/account", { replace: true, state: { user: data } });
      } catch (err) {
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Sign-in failed. Please try again.");
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    };
    if (sessionId) finish(); else navigate("/", { replace: true });
  }, [location, navigate, setPastor]);

  return (
    <div className="min-h-screen bg-[#FFF5F2] flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-5">
        <ArchWindow size={40} bar="#FFF5F2" />
        <p className="font-orbitron text-xs tracking-[0.35em] text-[#E84C4C]">SIGNING YOU IN</p>
      </div>
    </div>
  );
}
